import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom"
import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react";
import i18n from "../../i18n/i18n";
import { Box, CircularProgress, Grid, MenuItem, useMediaQuery, useTheme } from "@mui/material";
import Header from "../../components/PageHeader/header";
import { useTranslation } from "react-i18next";
import notify from "../../components/notify";
import { useFormik } from "formik";
import * as Yup from "yup";
import SubmitButton from "../../components/Utilities/SubmitButton";
import { GET_ALL_FACULITIES } from "../../graphql/facultyQuiries";
import LoadingPage from "../../components/LoadingComponent";
import { useEffect, useRef, useState } from "react";
import HorizentalTextField, { HorizentalTextFieldSelect } from "../../components/Utilities/HorizentalTextField";
import { GET_DEPARTMENTS_BY_FATHER_ID_FOR_ADMIN, GET_WEBSITE_DEPARTMENTS_BY_ADMIN, UPDATE_WEBSITE_DEPARTMENT_BY_ID } from "../../graphql/departmentsQueries";

import axios from "axios";
import { baseURL } from "../../Api/apolloClient";
import UploadFileField from "../../components/Utilities/UploadFileField";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import DashboardFilterComponent from "../../components/Utilities/DashboardFilterComponent";
import TableComponent from "../../components/TableComponent/TableComponent";
import logger from "../../utils/logger";

export default function WebSiteDepartmentDetailsPage() {
    const theme = useTheme();
    const { t } = useTranslation();
    const isArabic = i18n.language === "ar";
    const navigate = useNavigate();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const location = useLocation();
    const{id}=useParams();

    const [
        UpdateWebsiteDepartment,
        {
            data,
            loading
        }
    ] = useMutation(UPDATE_WEBSITE_DEPARTMENT_BY_ID, { fetchPolicy: "network-only" });

    const [
        GetDepartmentsByFather,
        {
            data: { getDepartmentsByFather } = {},
            loading: getDepartmentsByFatherLoading
        }
    ] = useLazyQuery(GET_DEPARTMENTS_BY_FATHER_ID_FOR_ADMIN, { fetchPolicy: "network-only" });

    const {
        data: { websiteDepartments } = {},
        loading:websiteDepartmentsLoading
      } = useQuery(GET_WEBSITE_DEPARTMENTS_BY_ADMIN, { fetchPolicy: "network-only" });

    useEffect(() => {
        GetDepartmentsByFather({ variables: { father_id: id } });
    }, []);

    const fileInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedToShowFile, setSelectedToShowFile] = useState(null);
    const [progress, setProgress] = useState(0);

    const handlePickFile = () => {
        if (fileInputRef.current) fileInputRef.current.click();
    };

    const handleFileChange = async (e) => {
        const file = e.target.files?.[0] ?? null;

        setSelectedToShowFile(file?.name);

        const formData = new FormData();
        formData.append("file", file);

        try {
            setProgress(0);

            const res = await axios.post(`${baseURL}/api/forms/single`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                onUploadProgress: (progressEvent) => {
                    const percent = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    setProgress(percent);
                },
            });

            setSelectedFile(`${baseURL}${res?.data?.url}`);
        } catch (error) {
            notify(t("errorUplaod"), "error");
            logger.log("error", error.message);
        }
    };

    let columns = [
        // { key: "ID", label: "ID" },
        { key: "title_ar", label: t("Dashboard.NameInArabic") },
        { key: "title_en", label: t("Dashboard.NameInEnglish") },
        { key: "status", label: t("Status") }
        //  { key: "userType", label: t("User Type") }

    ];

    const fetchAndExport = async (type) => {
        try {
            const exportData = getDepartmentsByFather?.map((user) => ({
                ID: user.serial_num,
                "Full Name": user.name,
                Email: user.email,
                Mobile: user.mobile,
                "User Type": user.userType,
                Status: user.status,
            }));

            if (type === "excel") {
                const ws = XLSX.utils.json_to_sheet(exportData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "Users");
                const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                const data = new Blob([excelBuffer], {
                    type: "application/octet-stream",
                });
                saveAs(data, `Users_${new Date().toISOString()}.xlsx`);
            } else if (type === "pdf") {
                const doc = new jsPDF();
                doc.text("Users Report", 14, 10);
                autoTable(doc, {
                    startY: 20,
                    head: [Object.keys(exportData[0] || {})],
                    body: exportData.map((row) => Object.values(row)),
                });
                doc.save(`Users_${new Date().toISOString()}.pdf`);
            } else if (type === "print") {
                const printableWindow = window.open("", "_blank");
                const htmlContent = `
                                   <html>
                                     <head>
                                       <title>Users Report</title>
                                       <style>
                                         table { width: 100%; border-collapse: collapse; }
                                         th, td { border: 1px solid #333; padding: 8px; text-align: left; }
                                         th { background-color: #f2f2f2; }
                                       </style>
                                     </head>
                                     <body>
                                       <h2>Users Report</h2>
                                       <table>
                                         <thead><tr>${Object.keys(exportData[0] || {})
                        .map((k) => `<th>${k}</th>`)
                        .join("")}</tr></thead>
                                         <tbody>${exportData
                        .map(
                            (row) =>
                                `<tr>${Object.values(row)
                                    .map((v) => `<td>${v}</td>`)
                                    .join("")}</tr>`
                        )
                        .join("")}</tbody>
                                       </table>
                                     </body>
                                   </html>
                                 `;
                printableWindow.document.write(htmlContent);
                printableWindow.document.close();
                printableWindow.print();
            }
        } catch (err) {
            logger.error("Export error:", err);
        }
    };

    const addNavigate = () => navigate("add");

    const handleDetailsClick = (selectedRow) => {
        logger.log('handleDetailsClick', selectedRow);
        navigate(`edit/${selectedRow?.id}`, {
            state: selectedRow
        });
    }

    const onStatusChange = async (selectedRow, newStatus) => {
        try {
            logger.log("selectedRow", selectedRow, newStatus);
            // return;
            let data = {
                status: newStatus == "inActive" ? false : true
            }

            const result = await UpdateWebsiteDepartment({
                variables: {
                    id: selectedRow?.id,
                    input: data
                }
            });

            logger.log("reeesult", result);

            notify(t("success"), "success");

        } catch (error) {
            notify(t("error"), "error");
        }
    }

   

    // logger.log("faculties", faculties);
    logger.log("location", location?.state);
    logger.log("getDepartmentsByFather", getDepartmentsByFather);

    let currentDep=websiteDepartments?.find(el=>el?.id==id);

    logger.log("currentDep",currentDep);

    // faculty_id?.id
    const formik = useFormik({
        initialValues: {
            // title_ar: currentDep?.title_ar,
            // title_en: currentDep?.title_en,
            // desc_ar: currentDep?.desc_ar,
            // desc_en: currentDep?.desc_en
            // faculty_id: ""
            // flag: "",
        },

        validationSchema: Yup.object({
            title_ar: Yup.string().required(t("admissions.errors.required")),
            title_en: Yup.string().required(t("admissions.errors.required")),
            // faculty_id: Yup.string().required(t("admissions.errors.required")),

        }),
        onSubmit: async (values) => {

            // ✅ التحقق اليدوي قبل الإرسال
            // if (selected==0) {
            //     setSelectError(t("admissions.errors.required"));
            //     return; // وقف الإرسال لحد ما المستخدم يختار
            // }
            logger.log('xxxxxxxxxxxxxxxxxxxxxxx');
            const data = {
                title_ar: values?.title_ar,
                title_en: values?.title_en,
                desc_ar: values?.desc_ar,
                desc_en: values?.desc_en
            };

            if (selectedFile != null) data.image = selectedFile;

            try {
                logger.log("uuuuuuuuuuuuuuuuuuuuuuuuuu");
                logger.log(data);

                const result = await UpdateWebsiteDepartment({
                    variables: {
                        id: id,
                        input: data
                    }
                });

                logger.log('result', result);

                notify(t("success"), "success");

                navigate('/website-departments');

            } catch (error) {
                logger.error("Error logging in:", error);
                notify(t("error"), "error");

            } finally {
                //  setIsLoading(false);
            }
        },
    });

     useEffect(()=>{
        let currentDep=websiteDepartments?.find(el=>el?.id==id);
        if(currentDep?.id){
            formik.values.title_ar=currentDep?.title_ar;
            formik.values.title_en=currentDep?.title_en;
            formik.values.desc_ar=currentDep?.desc_ar;
            formik.values.desc_en=currentDep?.desc_en;
            if (currentDep?.image && !selectedToShowFile) {
                setSelectedToShowFile(currentDep.image.split("/").pop());
            }
        }
    },[websiteDepartments]);

    let translateText = isArabic ? "قسم" : "Department";
    let translateText2 = isArabic ? "القسم" : "Department";
    let translateText3 = isArabic ? "عنوان فرعي" : "Sub Title";


    const hasViewPermission = true;
    const hasAddPermission = true;
    if (!hasViewPermission) return <Navigate to="/profile" />;

    if (getDepartmentsByFatherLoading || websiteDepartmentsLoading) return <LoadingPage />;

    // logger.log("DepartmentDetailsPage");
    return (
        <Box sx={{ p: 3, backgroundColor: "background.paper" }}>
            <Header
                title={t("departments")}
                subtitle={t("detailsItem", { item: translateText })}
                i18n={i18n}
                haveBtn={false}
                hasAddOrEditBtn={true}
                sub2={t("detailsItem", { item: translateText })}
                hasNavigate={true}
                isExcel={false}
                isPdf={false}
                isPrinter={false}
            />

         <Grid 
  container 
  component="form" 
  onSubmit={formik.handleSubmit} 
  spacing={3} // Adds consistent vertical/horizontal gap
//   sx={{ width: isMobile ? "50%" : "100%" }}
>
    {/* Arabic Title */}
    <Grid item xs={12}>
        <HorizentalTextField
            title={t("form.name_ar", { item: translateText2 })}
            fieldID={"title_ar"}
            fieldName={"title_ar"}
            placeholder={t("form.name_ar", { item: translateText2 })}
            value={formik.values.title_ar}
            onChange={formik.handleChange}
            error={formik.touched.title_ar && Boolean(formik.errors.title_ar)}
            helperText={formik.touched.title_ar && formik.errors.title_ar}
        />
    </Grid>

    {/* English Title */}
    <Grid item xs={12}>
        <HorizentalTextField
            title={t("form.name_en", { item: translateText2 })}
            fieldID={"title_en"}
            fieldName={"title_en"}
            placeholder={t("form.name_en", { item: translateText2 })}
            value={formik.values.title_en}
            onChange={formik.handleChange}
            error={formik.touched.title_en && Boolean(formik.errors.title_en)}
            helperText={formik.touched.title_en && formik.errors.title_en}
        />
    </Grid>

    {/* Arabic Description */}
    <Grid item xs={12}>
        <HorizentalTextField
            isMultiline={true}
            title={t("Dashboard.arDescription", { item: translateText2 })}
            fieldID={"desc_ar"}
            fieldName={"desc_ar"}
            placeholder={t("Dashboard.arDescription", { item: translateText2 })}
            value={formik.values.desc_ar}
            onChange={formik.handleChange}
            error={formik.touched.desc_ar && Boolean(formik.errors.desc_ar)}
            helperText={formik.touched.desc_ar && formik.errors.desc_ar}
        />
    </Grid>

    {/* English Description */}
    <Grid item xs={12}>
        <HorizentalTextField
            isMultiline={true}
            title={t("Dashboard.enDescription", { item: translateText2 })}
            fieldID={"desc_en"}
            fieldName={"desc_en"}
            placeholder={t("Dashboard.enDescription", { item: translateText2 })}
            value={formik.values.desc_en}
            onChange={formik.handleChange}
            error={formik.touched.desc_en && Boolean(formik.errors.desc_en)}
            helperText={formik.touched.desc_en && formik.errors.desc_en}
        />
    </Grid>

    {/* Image */}
    <Grid item xs={12}>
        {currentDep?.image && (
            <Box
                component="img"
                src={selectedFile || currentDep.image}
                alt={isArabic ? currentDep?.title_ar : currentDep?.title_en}
                sx={{
                    width: "100%",
                    maxWidth: 200,
                    height: 150,
                    objectFit: "cover",
                    borderRadius: 1,
                    mb: 1,
                    border: "1px solid rgba(0,0,0,0.1)",
                }}
            />
        )}
        <UploadFileField
            title={t("Dashboard.mainImage")}
            subTitle={t("admissions.addFile")}
            fileInputRef={fileInputRef}
            handleFileChange={handleFileChange}
            handlePickFile={handlePickFile}
            selectedToShowFile={selectedToShowFile}
            progress={progress}
        />
    </Grid>

    {/* Submit Button */}
    <Grid item xs={12}>
        <SubmitButton loading={loading} t={t} />
    </Grid>
</Grid>

            {
                loading && <CircularProgress
                    size={26}
                    thickness={8}
                    sx={{ color: "black" }}
                />
            }

            <Grid container spacing={3}>
                <Grid item
                    sm={12} md={12}
                    sx={{
                        overflowX: "auto", // ✅ مهم جدًا عشان الجدول يعمل scroll داخل الـ Grid
                    }}
                >
                    <Header
                        title={t("Dashboard.subtitle")}
                        subtitle={`${t("Dashboard.subtitle")}`}
                        i18n={i18n}
                        haveBtn={hasAddPermission}
                        btn={t("addItem", { item: translateText3 })}
                        btnIcon={<ControlPointIcon sx={{ [isArabic ? "mr" : "ml"]: 1 }} />}
                        onSubmit={addNavigate}
                        isExcel
                        isPdf
                        isPrinter
                        onExcel={() => fetchAndExport("excel")}
                        onPdf={() => fetchAndExport("pdf")}
                        onPrinter={() => fetchAndExport("print")}
                    />

                    <DashboardFilterComponent t={t} />


                    <TableComponent
                        columns={columns}
                        data={getDepartmentsByFather}
                        // onViewDetails={(r) => navigate(`/userDetails/${r.id}`)}
                        loading={getDepartmentsByFatherLoading}
                        // isUsers={true}
                        statusKey="status"
                 
                        handleDetailsClick={handleDetailsClick}
                        onStatusChange={onStatusChange}
                    />
                </Grid>
            </Grid>

        </Box>
    )
}


